import { useApi } from "../service/ApiContext";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useNavigate } from "react-router-dom";
import "../styles/InvalidateUrlPageStyles.css";
const InvalidateUrlHandlerpage: React.FC = () => {
  const navigate = useNavigate();
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );

  return (
    <div className="invalid-buttonPage">
      <center>
        <h2 className="invalid-buttonTitle">Page not found</h2>
        <p className="invalid-buttonSubTitle">
          The requested page does not exist.
        </p>
        <button
          className="invalid-button"
          onClick={() =>
            navigate(
              profileData.partner_institute === true
                ? "/dashboard/learning-room"
                : "/dashboard/student",
              { replace: true },
            )
          }
        >
          Go to Dashboard
        </button>
      </center>
    </div>
  );
};

export default InvalidateUrlHandlerpage;
